<div class="row">
  <div class="col-md-12 text-right">
    <button mat-raised-button
            (click)="handleSubmit()"
            [ngClass]="abstractForm.valid ? 'btn-success' : 'btn-danger'">Submit</button>
    <button mat-raised-button (click)="handleCancel()">Cancel</button>
  </div>
</div>

<form [formGroup]="abstractForm">
  <mat-card class="odp-text-abstract-subheader col-md-3 my-3">Abstract Details:</mat-card>
  
  <div class="row">
    <div class="col-md-5 odp-col-padding">
      <mat-form-field>
        <mat-label>User ID</mat-label>
        <input matInput [value]="userName" disabled>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Date Modified</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Project Title</mat-label>
        <input matInput formControlName="projectTitle">
      </mat-form-field>
      <mat-form-field>  
        <mat-label>Administering IC</mat-label>
        <input matInput formControlName="administeringIC">
      </mat-form-field>
    </div>

    <div class="col-md-5">
      <mat-form-field>  
        <mat-label>Application ID</mat-label>
        <input matInput formControlName="applicationID">
      </mat-form-field>
      <mat-form-field>  
        <mat-label>PI Project Leader</mat-label> 
        <input matInput formControlName="piProjectLeader">
      </mat-form-field>
      <mat-form-field>
        <mat-label>FY</mat-label>
        <!-- TODO: Get list of FY dynamically -->
        <mat-select formControlName="fy">
          <mat-option [value]="2013">2013</mat-option>
          <mat-option [value]="2014">2014</mat-option>
          <mat-option [value]="2015">2015</mat-option>
          <mat-option [value]="2016">2016</mat-option>
          <mat-option [value]="2017">2017</mat-option>
          <mat-option [value]="2018">2018</mat-option>
          <mat-option [value]="2019">2019</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Project Number</mat-label>
        <input matInput formControlName="projectNumber">
      </mat-form-field>
    </div>
  </div>

  <mat-card class="odp-text-abstract-subheader col-md-3 my-3">Description:</mat-card>
  <div class="row">
    <mat-form-field class="col-md-10 odp-col-padding">
      <textarea matInput title="Description"
                cdkTextareaAutosize
                cdkAutosizeMaxRows="10"
                formControlName="description"></textarea>
    </mat-form-field>
  </div>
  
  <mat-card class="odp-text-abstract-subheader col-md-3 my-3">Public Health Relevance:</mat-card>
  <div class="row">
    <mat-form-field class="col-md-10 odp-col-padding">
      <textarea matInput title="Public health relevance"
                cdkTextareaAutosize
                cdkAutosizeMaxRows="10"
                formControlName="publicHealthRel"></textarea>
    </mat-form-field>
  </div>

</form>
